import { baseApi as api } from "@/request/viewgres_v4";
import qs from "qs";

let baseUrl = "/products";

export function GetProductList(params = { page: 0, size: 20 }) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `${baseUrl}?${qs.stringify(params, {
          arrayFormat: "repeat"
        })}`
      )
      .then(res => {
        if (res.status === 200 || res.status === 206) {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
export function GetProductById(id = null) {
  return new Promise((resolve, reject) => {
    api
      .get(`${baseUrl}/${id}`)
      .then(res => {
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
